// src/pages/shared/MyGames.jsx
// "Find me": pick who you are and see when and where you play, with whom and against whom, and how it went.
import React from 'react';
import { currentGame, gamesOf } from './findMe';

const together = (names) => names.join(' & ');

function describe(game) {
    if (game.status === 'sits-out') return 'You sit this round out.';
    if (game.status === 'absent') return 'You are not in this round.';
    const withWhom = game.isSingles || game.partners.length === 0 ? 'You' : `You & ${together(game.partners)}`;
    return `${withWhom} vs ${together(game.opponents)}`;
}

const RESULT = { won: 'Won', lost: 'Lost', draw: 'Draw' };

export function PlayerPicker({ standings, value, onChange }) {
    return (
        <label className="find-me">
            <span className="label">Find me</span>
            <select value={value ?? ''} onChange={(event) => onChange(event.target.value === '' ? null : Number(event.target.value))}>
                <option value="">Choose your name…</option>
                {[...standings]
                    .sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`))
                    .map((player) => (
                        <option key={player.playerId} value={player.playerId}>
                            {player.firstName} {player.lastName}
                        </option>
                    ))}
            </select>
        </label>
    );
}

function MyGames({ rounds, playerId, courts, name, standings }) {
    const games = gamesOf(rounds, playerId, courts);
    const now = currentGame(games);
    const mine = standings.find((row) => row.playerId === playerId);
    return (
        <section className="card my-games" aria-label="My games">
            <h2>{name}</h2>
            {mine && (
                <p className="muted">
                    Place {mine.rank} of {standings.length} · {mine.matchesWon}–{mine.matchesLost} in matches
                </p>
            )}
            {!now ? (
                <p className="hint">No rounds yet. Your first game shows up here as soon as it is planned.</p>
            ) : (
                <div className={`now${now.status === 'plays' ? '' : ' resting'}`}>
                    <span className="label">Round {now.round}</span>
                    {now.status === 'plays' && now.court && <strong className="court">Court {now.court}</strong>}
                    <span>{describe(now)}</span>
                    {now.cancelled && <span className="badge badge-cancelled">Cancelled</span>}
                </div>
            )}
            {games.length > 1 && (
                <ul className="my-history" aria-label="Earlier rounds">
                    {[...games]
                        .slice(0, -1)
                        .reverse()
                        .map((game) => (
                            <li key={game.roundId}>
                                <span className="label">Round {game.round}</span> {describe(game)}
                                {game.sets.length > 0 && (
                                    <span className="my-score">
                                        {' '}
                                        {game.sets.map(([a, b]) => `${a}–${b}`).join(', ')}
                                        {game.result && ` · ${RESULT[game.result]}`}
                                    </span>
                                )}
                            </li>
                        ))}
                </ul>
            )}
        </section>
    );
}

export default MyGames;
